/* eslint camelcase: 0, no-underscore-dangle: 0 */

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import PropTypes from "prop-types";

import Tooltip from '@material-ui/core/Tooltip';

import * as actionCreators from '../actions/auth';

import { validateEmail } from '../utils/misc';

function mapStateToProps(state) {
    return {
        isRegistering: state.auth.isRegistering,
        registerStatusText: state.auth.statusText,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

const style = {
    marginTop: 100,
    paddingBottom: 50,
    paddingTop: 25,
    width: '100%',
    textAlign: 'center',
    display: 'inline-block',
};

@connect(mapStateToProps, mapDispatchToProps)
export default class RegisterView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            phone: '',
            TIN: '',
            password: '',
            password2: '',
            username: '',
            email_error_text: null,
            phone_error_text: null,
            username_error_text: null,
            password_error_text: null,
            password2_error_text: null,
            TIN_error_text: null,
            disabled: true,
        };
    }

    isDisabled() {
        let email_is_valid = false;
        let password_is_valid = false;
        let password2_is_valid = false;
        let phone_is_valid = false;
        let username_is_valid = false;
        let TIN_is_valid = false;
        
        if (this.state.email === '') {
            this.setState({
                email_error_text: null,
            });
        } else if (validateEmail(this.state.email)) {
            email_is_valid = true;
            this.setState({
                email_error_text: null,
            });

        } else {
            this.setState({
                email_error_text: 'Ingrese un email valido',
            });
        }

        if (this.state.password === '' || !this.state.password) {
            this.setState({
                password_error_text: null,
            });
        } else if (this.state.password.length >= 6) {
            password_is_valid = true;
            this.setState({
                password_error_text: null,
            });
        } else {
            this.setState({
                password_error_text: 'La clave debe contener al menos 6 caracteres',
            });

        }
        if (this.state.password2 != this.state.password) {
            this.setState({
                password2_error_text: "Las claves no coinciden",
            })
        }
        else{
            password2_is_valid = true;
            this.setState({
                password2_error_text: null,
            })
        }
        const barePhone = this.state.phone.split(' ').join('').split('-').join('');
        if (this.state.phone === '') {
            this.setState({
                phone_error_text: null,
            });
        }

        
        else if (barePhone.length > 6 && !isNaN(barePhone)){
            phone_is_valid = true;
            this.setState({
                phone_error_text: null,
            });
        }
        else{
            this.setState({
                phone_error_text: "Ingrese un telefono valido"
            })
        }
        if (!this.state.username || this.state.username === ''){
            this.setState({
                password_error_text: null,
            });
        } else if (this.state.username.trim().length >= 2) {
            username_is_valid = true;
            this.setState({
                username_error_text: null,
            });
        } else {
            this.setState({
                username_error_text: 'Ingrese el nombre de su empresa',
            });

        }
        const bareTin = this.state.TIN.split(' ').join('').split('-').join('');
        if (!bareTin|| bareTin=== ''){
            this.setState({
                TIN_error_text: null,
            })
        }
        else if(bareTin.length > 10){
            TIN_is_valid = true;
            this.setState({
                TIN_error_text: null,
            })
        }
        else{
            this.setState({
                TIN_error_text: 'Ingrese un CUIT valido',
            });
        }

        if (email_is_valid && password_is_valid &&
            password2_is_valid && phone_is_valid &&
            username_is_valid && TIN_is_valid) {
            this.setState({
                disabled: false,
            });
        }

    }

    changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state, () => {
            this.isDisabled();
        });
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            if (!this.state.disabled) {
                this.login(e);
            }
        }
    }

    register(e) {
        e.preventDefault();
        const bareTin = this.state.TIN.split(' ').join('').split('-').join('');
        const barePhone = this.state.phone.split(' ').join('').split('-').join('');
        this.props.registerUser(this.state.email.trim(),
                                this.state.password.trim(),
                                bareTin,
                                barePhone,
                                this.state.username.trim());
    }

    render() {
        return (
            <div className="col-md-6 col-md-offset-3" onKeyPress={(e) => this._handleKeyPress(e)}>
                <Paper style={style}>
                    <div className="text-center">
                        <h2>Ingrese sus datos</h2>
                        {
                            this.props.registerStatusText &&
                            <div className="alert alert-info">
                                {this.props.registerStatusText}
                            </div>
                        }
                        <div className="col-md-12">
                            <TextField
                                error={Boolean(this.state.username_error_text)}
                                placeholder="Nombre Empresa"
                                type="text"
                                helperText={this.state.username_error_text}
                                onChange={(e) => this.changeValue(e, 'username')}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                error={Boolean(this.state.TIN_error_text)}
                                placeholder="CUIT"
                                type="text"
                                helperText={this.state.TIN_error_text}
                                onChange={(e) => this.changeValue(e, 'TIN')}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                error={Boolean(this.state.email_error_text)}
                                placeholder="empresa@mail.com"
                                type="email"
                                helperText={this.state.email_error_text}
                                onChange={(e) => this.changeValue(e, 'email')}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                error={Boolean(this.state.phone_error_text)}
                                placeholder="0291-123456"
                                type="text"
                                helperText={this.state.phone_error_text}
                                onChange={(e) => this.changeValue(e, 'phone')}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                placeholder="Clave"
                                type="password"
                                helperText={this.state.password_error_text}
                                onChange={(e) => this.changeValue(e, 'password')}
                            />
                        </div>
                        <div className="col-md-12">
                            <TextField
                                placeholder="Reingresar Clave"
                                type="password"
                                helperText={this.state.password2_error_text}
                                onChange={(e) => this.changeValue(e, 'password2')}
                            />
                        </div>
                        
                        <div className="col-md-12">
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={this.state.disabled}
                                onClick={(e) => this.register(e)}
                            >
                                Enviar
                            </Button>
                        </div>

                    </div>
                </Paper>

            </div>
        );

    }
}

RegisterView.propTypes = {
    registerUser: PropTypes.func,
    registerStatusText: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/RegisterView.js